import {z} from 'zod';

export const AccountDataResetStatusSchema = z.object({
  state: z.enum(['idle', 'running', 'failed', 'complete']),
  requestId: z.uuid().nullable(),
  phase: z.enum(['queued', 'quiescing', 'reconciling', 'clearing-memory', 'clearing-runtime', 'finalizing', 'complete']).nullable(),
  error: z.string().nullable(),
  updatedAt: z.iso.datetime().nullable()
}).strict();
export type AccountDataResetStatus = z.infer<typeof AccountDataResetStatusSchema>;
export const AccountDataResetRequestSchema = z.object({confirmation: z.literal('confirm'), requestId: z.uuid()}).strict();
